import { isValidOptionalMdyDate, normalizeOptionalMdyDate } from '@/utils/date';

const INVOICE_DATE_FIELDS = [
	{ key: 'invoice_date_from', name: 'Invoice Date From' },
	{ key: 'invoice_date_to', name: 'Invoice Date To' },
];

const RECEIVED_DATE_FIELDS = [
	{ key: 'received_date_from', name: 'Received Date From' },
	{ key: 'received_date_to', name: 'Received Date To' },
];

function backOrderDateFields({ include_received = false } = {}) {
	return include_received ? INVOICE_DATE_FIELDS.concat(RECEIVED_DATE_FIELDS) : INVOICE_DATE_FIELDS;
}

export function getBackOrderDateValidationError(filters, options) {
	const source = filters || {};
	const invalid = backOrderDateFields(options).find(field => !isValidOptionalMdyDate(source[field.key]));
	return invalid ? invalid.name + ' must be a valid date in MM-DD-YYYY format.' : null;
}

export function normalizeBackOrderDateFilters(filters, options) {
	const error = getBackOrderDateValidationError(filters, options);
	if (error) throw new Error(error);

	const source = filters || {};
	return backOrderDateFields(options).reduce((result, field) => {
		result[field.key] = normalizeOptionalMdyDate(source[field.key]);
		return result;
	}, {});
}

export function validateBackOrderDatesWithToast(toast, filters, options) {
	const error = getBackOrderDateValidationError(filters, options);
	if (!error) return true;
	toast.error(error);
	return false;
}
